import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { setPopupContent } from '../../../features/account/slice'
import { Form } from './form'
import { FormReset } from './form-reset'

const directionText = {
  en: "Enter your email address below and we'll send you a link to reset your password.",
  id: "Masukkan alamat surel Anda di bawah ini dan kami akan mengirimkan tautan untuk mengatur ulang kata sandi Anda."
}

const directionTextReset = {
  en: "Check your email to get OTP and enter a new password.",
  id: "Cek surel Anda untuk mendapatkan OTP dan masukkan password baru."
}

const Content = ({embed, noRedirect}) => {
  const dispatch = useDispatch()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const resetPasswordStep = useSelector(state => state.account.resetPasswordStep)

  return (
    <div className={`w-full lg:w-10/12 mx-auto ${embed ? 'py-8' : 'min-h-screen'} h-full flex items-center`}>
      <div className="md:p-10 lg:p-20 w-full bg-white lg:rounded h-full lg:h-auto">
        <div className="flex flex-wrap -mx-4">
          <div className="mx-auto lg:mx-0 w-1/2 px-4 h-auto pt-24 lg:pt-2 lg:p-8">
            <img src="/images/khub_forgot.png" alt="forgot password" className="mb-5 lg:mb-0 mx-auto"/>
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <h1 className="text-2xl font-bold mb-3 font-primary text-center md:text-left">
              {translation.AUTH.forgot_your_password[language.name]}?
            </h1>
            <p className="text-sm text-gray-444 text-center md:text-left">
              {
                resetPasswordStep === 1 &&
                directionText[language.name]
              }
              {
                resetPasswordStep === 2 &&
                directionTextReset[language.name]
              }
            </p>

            {
              resetPasswordStep === 1 &&
              <Form className="my-4 md:my-5 lg:my-8" />
            }
            {
              resetPasswordStep === 2 &&
              <FormReset className="my-4 md:my-5 lg:my-8" noRedirect={noRedirect}/>
            }

            <p className="text-sm text-center md:text-left">
              {
                embed ? (
                  <span onClick={() => dispatch(setPopupContent('login'))} className="link underline">
                    {translation.AUTH.back_to_sign_in[language.name]}
                  </span>
                ) : (
                  <Link to="/login" className="link underline">
                    {translation.AUTH.back_to_sign_in[language.name]}
                  </Link>
                )
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Content }
